import { FC, ReactNode, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { useStore } from 'hooks/useRootStore';

export const AppProvider: FC<{ children: ReactNode }> = observer(({ children }) => {
  const {
    userStore: { token, user, loadUserProfileFromStorage },
    ldapStore: { getCredentials },
  } = useStore();
  useEffect(() => {
    if (token && !user) {
      const storedProfile = localStorage.getItem('Profile');
      if (storedProfile) {
        try {
          const profileData = JSON.parse(storedProfile);
          loadUserProfileFromStorage(profileData);
        } catch (error) {
          console.error('Error parsing stored profile:', error);
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // useEffect(() => {
  //   const publicPaths = ['/login', '/register', '/admin/forgot-password', '/admin/reset-password', '/user/forgot-password', '/user/reset-password', '/authenticate', '/2-fa', '/two-factor/recovery'];
  //   const isPublicPage = publicPaths.some(path => window.location.pathname.includes(path)) || window.location.pathname === '/';

  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [token, user]);

  useEffect(() => {
    let timeout: ReturnType<typeof setTimeout> | undefined;

    if (token && user) {
      timeout = setTimeout(() => {
        getCredentials();
      }, 5 * 60 * 1000);
    }

    return () => {
      if (timeout) {
        clearTimeout(timeout);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token, user]);

  return <>{children}</>;
});
